import styled, { css } from 'styled-components';
import ScrollContainer from '@Utils/shared/components/ScrollContainer';
import mediaQueries from '@Utils/shared/constants/mediaQueries';

export const Tooltip = styled.div<{ isShow: boolean; left: number }>`
  width: 360px;
  background-color: #fff;
  border-radius: 6px;
  border: 1px solid rgba(151, 151, 151, 0.2);
  box-shadow: 0 15px 30px -10px rgba(0, 0, 0, 0.4);
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
  position: fixed;
  text-align: center;
  z-index: 2;

  @media ${mediaQueries.tabletOrDesktop} {
    left: ${({ left }) => `${left}px`};
  }

  @media ${mediaQueries.mobile} {
    right: calc(50% - (355px / 2));
  }

  @media (max-width: 375px) {
    width: calc(100% - 20px);
  }

  ${({ isShow }) =>
    isShow &&
    css`
      opacity: 1;
      pointer-events: all;
    `};
`;

export const TooltipScrollContainer = styled(ScrollContainer)`
  max-height: 298px;
  padding: 15px 10px 5px 10px;
`;

export const TooltipTitle = styled.div`
  margin-bottom: 10px;
  font-size: 18px;
  line-height: 1;
  color: #2d2d30;
  font-weight: 500;
`;

export const TooltipText = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  margin-bottom: 5px;
  color: rgba(0, 0, 0, 0.6);
  letter-spacing: -0.5px;
`;

export const TooltipScreenshotsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

/**
 * TODO: where was theme z-index defined?
 * Should it be used here instead of hardcoded value?
 * Previously it was:
 * z-index: ${(props) => props.theme.zIndex.header + 1};
 */
